module.exports = __webpack_public_path__ + "img/qilin-stage3-sulking.5006a758.png";